import React, { useEffect } from "react";
import { DesktopDatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs, { Dayjs } from "dayjs";
import { Grid, InputLabel, MenuItem, Select } from "@mui/material";
import { useRepassesSetoriaisState } from "../context/repasses-setoriais-context";
import { useRepassesSetoriaisController } from "../context/repasses-setoriais-controller";
import PlainTextArea from "../../../components/plain-text-area";
import { CurrencyInput } from "../../../components/currency-input";

export const RepasseSetorialForm = () => {
    const { dataRequest, areasList, origensList } = useRepassesSetoriaisState();
    const { handleOnChangeForm, loadLookups } = useRepassesSetoriaisController();

    useEffect(() => {
        (async () => {
            await loadLookups();
        })();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <React.Fragment>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
                <Grid container spacing={2}>
                    <Grid item lg={6} sm={6} xl={6}>
                        <InputLabel>Área *</InputLabel>
                        <Select
                            size="small"
                            error={!dataRequest?.idAreaTransparenciaSetorial}
                            value={dataRequest?.idAreaTransparenciaSetorial ?? ''}
                            onChange={(e) => handleOnChangeForm('idAreaTransparenciaSetorial', e.target.value)}
                            fullWidth
                        >
                            <MenuItem value={''} key={0}><em>Selecionar</em></MenuItem>
                            {areasList?.slice().sort((a, b) => a.name.localeCompare(b.name, 'pt-BR')).map((a) => <MenuItem value={a.id} key={a.id}>{a.name}</MenuItem>)}
                        </Select>
                    </Grid>

                    <Grid item lg={6} sm={6} xl={6}>
                        <InputLabel>Origem *</InputLabel>
                        <Select
                            size="small"
                            error={!dataRequest?.idOrigemRepasseSetorial}
                            value={dataRequest?.idOrigemRepasseSetorial ?? ''}
                            onChange={(e) => handleOnChangeForm('idOrigemRepasseSetorial', e.target.value)}
                            fullWidth
                        >
                            <MenuItem value={''} key={0}><em>Selecionar</em></MenuItem>
                            {origensList?.slice().sort((a, b) => a.name.localeCompare(b.name, 'pt-BR')).map((o) => <MenuItem value={o.id} key={o.id}>{o.name}</MenuItem>)}
                        </Select>
                    </Grid>

                    <Grid item lg={3} sm={3} xl={3}>
                        <InputLabel>Ano *</InputLabel>
                        <Select
                            size="small"
                            error={!dataRequest?.ano}
                            value={dataRequest?.ano ?? ''}
                            onChange={(e) => handleOnChangeForm('ano', e.target.value)}
                            fullWidth
                        >
                            <MenuItem value={''} key={0}><em>Selecionar</em></MenuItem>
                            {Array.from({ length: 12 }, (_, i) => 2020 + i).map((y) => <MenuItem value={y} key={y}>{y}</MenuItem>)}
                        </Select>
                    </Grid>

                    <Grid item lg={4} sm={4} xl={4}>
                        <InputLabel>Valor Previsto *</InputLabel>
                        <CurrencyInput
                            size="small"
                            error={!dataRequest?.valorPrevisto || dataRequest.valorPrevisto <= 0}
                            value={dataRequest?.valorPrevisto}
                            onChange={(value) => handleOnChangeForm('valorPrevisto', value)}
                            fullWidth
                        />
                    </Grid>

                    <Grid item lg={5} sm={5} xl={5}>
                        <InputLabel>Valor Realizado *</InputLabel>
                        <CurrencyInput
                            size="small"
                            error={dataRequest?.valorRealizado === null || dataRequest?.valorRealizado === undefined}
                            value={dataRequest?.valorRealizado}
                            onChange={(value) => handleOnChangeForm('valorRealizado', value)}
                            fullWidth
                        />
                    </Grid>

                    <Grid item lg={12} sm={12} xl={12}>
                        <InputLabel>Descrição *</InputLabel>
                        <PlainTextArea
                            size="small"
                            rows={3}
                            error={!dataRequest?.textoDescricao}
                            value={dataRequest?.textoDescricao || ''}
                            onChange={(e: any) => handleOnChangeForm('textoDescricao', e.target.value)}
                            fullWidth
                        />
                    </Grid>

                    <Grid item lg={4} sm={4} xl={4}>
                        <InputLabel>Data de Publicação *</InputLabel>
                        <DesktopDatePicker
                            format='DD/MM/YYYY'
                            slotProps={{ textField: { fullWidth: true, size: "small", error: !dataRequest?.dtaPublicacao } }}
                            value={dataRequest?.dtaPublicacao ? dayjs(dataRequest.dtaPublicacao) : null}
                            onChange={(value: Dayjs | null) => handleOnChangeForm('dtaPublicacao', value?.toISOString())}
                        />
                    </Grid>
                </Grid>
            </LocalizationProvider>
        </React.Fragment>
    );
};
